import { Injectable } from '@angular/core';
import { PASSWORD_CHANGE_ERROR } from '../../../constants/login-remember-me-constant';
import { ErrorDetails } from '../../../models/errors.interfaces';

@Injectable({
  providedIn: 'root'
})
export class LoginRememberMeErrorExtendedUtilService {
  checkPasswordChangeErrorFailed(message?: string): string {
    const splitMessage = message?.split('|');
    let finalMessage = '';
    if (splitMessage && splitMessage.length > 1) {
      finalMessage = splitMessage[0];
    } else {
      finalMessage = 'PASSWORD_CHANGE_ERROR_RETRY';
    }
    return `ERROR_MSG_${finalMessage}`.toUpperCase();
  }

  splitUserMessage(userMessage: string): string {
    let message = '';
    if (userMessage) {
      const splitValue = userMessage.split('|');
      if (splitValue && splitValue.length > 1) {
        message = splitValue[0];
      } else {
        message = userMessage;
      }
    }
    return message;
  }

  checkPasswordChangeError(pingErrorDetails: ErrorDetails): boolean {
    return (
      pingErrorDetails &&
      pingErrorDetails.code === PASSWORD_CHANGE_ERROR &&
      !!pingErrorDetails.userMessage
    );
  }
}
